export default __webpack_public_path__ + "images/e3f20fc0d207038dcb05294eabd352ff-performance.jpg";